<template>
  <v-app>
    <template v-if="isMobile">
      <nav-drawer-mobile
        :drawer="drawer"
        @updated="drawer = $event"
      ></nav-drawer-mobile>
      <navbar-mobile @toggleMenu="drawer = !drawer"></navbar-mobile>
    </template>
    <template v-else>
      <navbar-desktop></navbar-desktop>
    </template>
    <v-main>
      <transition>
        <router-view></router-view>
      </transition>
      <app-footer></app-footer>
    </v-main>
    <v-btn
      fab
      v-scroll="onScroll"
      v-show="backToTop"
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    <app-snackbars :snackbars="snackbars"></app-snackbars>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    backToTop: false,
  }),
  computed: {
    ...mapState(['categories', 'window', 'snackbars']),
    ...mapGetters(['isMobile']),
  },
  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.backToTop = top > 200;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    onWindowResize() {
      this.$store.dispatch('onWindowResize');
    },
  },
  watch: {
    '$route'(to) {
      document.title = to.meta.title || this.$baseTitle;
    }
  },
  created() {
    window.addEventListener('resize', this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>
<style>
.v-footer {
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: calc(16px + env(safe-area-inset-left));
}
.v-main {
  padding-bottom: env(safe-area-inset-bottom) !important;
  padding-left: env(safe-area-inset-left) !important;
  padding-right: env(safe-area-inset-right) !important;
}
.v-footer ~ .v-main {
  padding-bottom: 0;
}

/* Begin Router Animation */
.route-anim-enter,
.route-anim-leave {
  opacity: 0;
  transform: translateX(5em);
}
.route-anim-enter-active,
.route-anim-leave-active {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* End Router Animation */
/* Change the white to any color ;) */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #1e1e1e inset !important;
}
/*Change text in autofill textbox*/
input:-webkit-autofill {
  -webkit-text-fill-color: #fff !important;
}
.copyright {
  font-size: smaller;
}
</style>
